import { Icon } from 'design-system';
import { AppUsersIcon } from 'layout/components/sidebar/icons/app-users-icon';
import { CatalogIcon } from 'layout/components/sidebar/icons/catalog-icon';
import { CountiesIcon } from 'layout/components/sidebar/icons/counties-icon';
import { OrdersIcons } from 'layout/components/sidebar/icons/orders-icons';
import { OtpIcon } from 'layout/components/sidebar/icons/otp-icon';
import { RestaurantsIcons } from 'layout/components/sidebar/icons/restaurants-icons';
import { SuppliersIcon } from 'layout/components/sidebar/icons/suppliers-icon';
import { UserManagementIcon } from 'layout/components/sidebar/icons/user-management-icon';
import { FiSend, FiShoppingCart } from 'react-icons/fi';

export type TSidebarItem = {
  name: string;
  path: string;
  icon: typeof Icon;
  children?: {
    name: string;
    path: string;
    disable?: boolean;
    group?: string; // New: Group identifier for better organization
  }[];
  hasSocket?: boolean;
  disable?: boolean;
};

export type TSidebarGroup = {
  type: 'group';
  title: string;
  items: TSidebarItem[];
};

export type TSidebarDivider = {
  type: 'divider';
  label?: string;
};

export type TSidebarElement = TSidebarItem | TSidebarGroup | TSidebarDivider;

const GpoIcon = (props: any) => <Icon as={FiShoppingCart} width='22px' height='22px' fill='#757575' {...props} />;
const NotificationProvidersIcon = (props: any) => (
  <Icon as={FiSend} width='22px' height='22px' color='#757575' {...props} />
);

export const useSidebarItems = () => {
  const sidebarItems: TSidebarItem[] = [
    {
      name: 'sidebar.restaurants',
      path: '/app/restaurants',
      icon: RestaurantsIcons,
      children: [
        {
          name: 'Restaurants',
          path: '/app/restaurants/list',
        },
        {
          name: 'Documents',
          path: '/app/restaurants/documents',
        },
      ],
    },
    {
      name: 'sidebar.suppliers',
      path: '/app/suppliers',
      icon: SuppliersIcon,
    },
    {
      name: 'sidebar.catalogManagement',
      path: '/app/catalog',
      icon: CatalogIcon,
      children: [
        {
          name: 'Food Universe',
          path: '/app/catalog/food-universe',
          disable: true,
        },
        {
          name: 'Product Categories',
          path: '/app/catalog/product-categories',
        },
        {
          name: 'Product Attributes',
          path: '/app/catalog/product-attributes',
        },
        {
          name: 'Product Brands',
          path: '/app/catalog/product-brands',
        },
      ],
    },
    {
      name: 'sidebar.appUsers',
      path: '/app/app-users',
      icon: AppUsersIcon,
    },
    {
      name: 'sidebar.orders',
      path: '/app/orders',
      icon: OrdersIcons,
    },
    {
      name: 'GPO',
      path: '/app/gpo',
      icon: GpoIcon,
      children: [
        { name: 'Inquiries', path: '/app/inquiry-processor/list' },
        {
          name: 'Master Products',
          path: '/app/inquiry-processor/master-products',
        },
        {
          name: 'GPO Suppliers',
          path: '/app/supplier-profiles/list',
        },
        {
          name: 'Reconciliation',
          path: '/app/reconciliation/list',
        },
        {
          name: 'GPO Orders',
          path: '/app/gpo-orders/list',
        },
        {
          name: 'Prices',
          path: '/app/prices/list',
        },
        { name: 'Sales Lookup', path: '/app/sales-lookup/list' },
      ],
    },
    {
      name: 'sidebar.userManagement',
      path: '/app/user-management',
      icon: UserManagementIcon,
    },
    {
      name: 'sidebar.otp',
      path: '/app/sms-otp',
      icon: OtpIcon,
    },
    {
      name: 'sidebar.countries',
      path: '/app/countries',
      icon: CountiesIcon,
    },
    {
      name: 'Notification Providers',
      path: '/app/notification-providers',
      icon: NotificationProvidersIcon,
    },
  ];

  return sidebarItems;
};
